import axios from 'axios';
import { objectToQuery } from 'common/helpers/filters.helper';
import {
  IAnnouncementCollection,
  IAnnouncementCollectionFilter,
  IAnnouncementCreateData,
  IAnnouncementModel,
  IAnnouncementUpdateData,
} from 'entities/Announcement/Announcement.models';

const basePath = '/announcements';

export const announcementTransport = {
  getCollection: (filter?: IAnnouncementCollectionFilter): Promise<IAnnouncementCollection> =>
    axios.get(`${basePath}${objectToQuery(filter)}`),
  get: (id: string): Promise<IAnnouncementModel> => axios.get(`${basePath}/${id}`),
  add: (params: IAnnouncementCreateData): Promise<IAnnouncementModel> => axios.post(`${basePath}`, params),
  update: ({ id, ...rest }: IAnnouncementUpdateData): Promise<IAnnouncementModel> =>
    axios.put(`${basePath}/${id}`, rest),
  updateVisibility: (id: string, isHidden: boolean): Promise<IAnnouncementModel> =>
    axios.put(`${basePath}/${id}/visibility`, { isHidden }),
};
